<template>
    <div>
        <div class="form">
            <div class="checkoutPage">
                <div class="columns is-multiline">
                    <div class="column is-4">
                        <div class="card card-left">
                            <div class="imgWrapper">
                                <img src="@/assets/box.png" alt="logo">
                            </div>
                            <div class="details">
                                <h3 v-if="formData.product_type === 'fresh'">
                                    TupiBox Fresh para {{formData.petname}}
                                </h3>
                                <h3 v-else>
                                    TupiBox para {{formData.petname}}
                                </h3>
                                
                                <!-- Fresh: Mostrar peso y porciones -->
                                <div class="item" v-if="formData.product_type === 'fresh'">
                                    <p>Plan {{getPlanName()}} ({{formData.weight}}kg)</p>
                                    <span>{{formData.originalPrice / multiplier | currency}} CLP</span>
                                </div>
                                <div class="item" v-if="formData.product_type === 'fresh'">
                                    <p>Porciones/mes</p>
                                    <span>{{getPortions()}} porciones</span>
                                </div>
                                
                                <!-- Toys: Mostrar boxSize -->
                                <div class="item" v-if="formData.product_type !== 'fresh'">
                                    <p>{{formData.boxSize}} Box</p>
                                    <span>{{formData.originalPrice / multiplier | currency}} CLP</span>
                                </div>
                                
                                <!-- Extra: Snacks (Fresh) o Juguete (Toys) -->
                                <div class="item" v-if="formData.extraToy === 'Si'">
                                    <p v-if="formData.product_type === 'fresh'">Snacks saludables</p>
                                    <p v-else>Juguete extra</p>
                                    <span v-if="formData.product_type === 'fresh'">{{prices.extra_snacks | currency}} CLP</span>
                                    <span v-else>{{prices.extratoy | currency}} CLP</span>
                                </div>
                                <div class="item">
                                    <p>Plan</p>
                                    <span>x {{multiplier}} Meses</span>
                                </div>
                                <div class="item">
                                    <p>Pago</p>
                                    <span v-if="formData.payMethod === 'subscription'">Suscripción</span>
                                    <span v-else>Único</span>
                                </div>
                                <div class="item">
                                    <p>Envío</p>
                                    <span>Gratis</span>
                                </div>
                                <div class="item">
                                    <b-field class="mergeInputs">
                                        <template v-if="!loadingDiscountCode">
                                            <b-input v-model="discountCode" placeholder="Cupon de descuento" :disabled="disabledDiscount"></b-input>
                                            <button @click="applyDiscount" class="button is-primary" :disabled="disabledDiscount">Aplicar</button>
                                        </template>
                                        <div v-else class="loading-inline">
                                            <loader></loader>
                                        </div>
                                    </b-field>
                                </div>
                                <hr>
                                <div class="item">
                                    <p>Total</p>
                                    <span>{{formData.price | currency}} CLP</span>
                                </div>
                            </div>
                        </div>

                        <div class="warranty">
                            <img src="@/assets/warranty.png" alt="logo">
                            <p v-if="formData.product_type === 'fresh'">
                                <strong>Garantía TupiBox Fresh:</strong> Si {{formData.petname}} no está 100% satisfecho con su comida Le Fov, trabajaremos contigo para ajustar el plan perfecto.
                            </p>
                            <p v-else>
                                Si tu mascota no está 100% satisfecha con algún producto de TupiBox, te enviamos uno de regalo y logramos que funcione nuestra relación.
                            </p>
                        </div>
                        
                    </div>
                    <div class="column is-8">
                        <div class="card card-right">
                            <div class="titleStep">
                                <h1>Completa tus datos</h1>
                                <p>Detalles para realizar el envio.</p>
                            </div>
                            <b-field>
                                <b-input v-model.trim="payData.name" placeholder="Nombre completo"></b-input>
                            </b-field>
                            <div class="column is-12 v-column" v-if="$v.payData.name.$error">
                                <p class="help is-danger">Nombre inválido</p>
                            </div>
                            <b-field>
                                <b-input v-model.trim="payData.address" placeholder="Dirección Completa"></b-input>
                            </b-field>
                            <div class="column is-12 v-column" v-if="$v.payData.address.$error">
                                <p class="help is-danger">Dirección inválida</p>
                            </div>
                            <b-field>
                                <b-input v-model.trim="payData.city" placeholder="Ciudad"></b-input>
                            </b-field>
                            <div class="column is-12 v-column" v-if="$v.payData.city.$error">
                                <p class="help is-danger">Ciudad inválida</p>
                            </div>
                            <b-field>
                                <b-input 
                                    v-model.trim="payData.phone" 
                                    placeholder="9 1234 5678"
                                    @input="formatPhoneNumber"
                                    maxlength="11"
                                ></b-input>
                                <p class="help">Formato: 9 1234 5678 (se agregará +56 automáticamente)</p>
                            </b-field>
                            <div class="column is-12 v-column" v-if="$v.payData.phone.$error">
                                <p class="help is-danger">Teléfono inválido (debe ser 9 dígitos)</p>
                            </div>
                            <b-button type="is-primary nextButton" id="step-checkout-pay" @click="submitPayForm">Pagar con Mercado Pago</b-button>
                            <div class="logoPay">
                                <img src="@/assets/mercadopago.png" alt="logo">
                            </div>
                        </div>

                        <div class="backWrapper">
                            <a class="backStep" @click="backStep">Volver</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Logo from '@/assets/mercadopago.png'
    import Loader from '../Loader.vue'
    import {validationMixin} from 'vuelidate'
    import {required, minLength, maxLength} from 'vuelidate/lib/validators'
    import StepMixin from '../../mixins/StepMixin'
    import crypto from 'crypto'
    import shortid  from 'shortid'
    import uuidv4 from 'uuid/v4'
    import axios from 'axios'

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, StepMixin],
        components : {
            Loader
        },
        data() {
            return {
                payload : {},
                payData : {},
                discountCode : '',
                disabledDiscount : false,
                loadingDiscountCode: false
            }
        },
        computed: {
            formData(){
                return this.$parent.$parent.$parent.formData 
            },
            multiplier (){
                try {
                    return this.$parent.$parent.$parent.formData.plan.slice(-1)
                } catch (error) {
                    return 1
                }
            },
            prices(){
                return this.$parent.$parent.$parent.configs.prices 
            }
        },
        validations: {
            payData: {
                name: { required },
                address: { required },
                city: { required },
                phone: { 
                    required,
                    minLength: minLength(11), // "9 1234 5678"
                    maxLength: maxLength(11)
                },
            },
        },
        watch: {
            payData: {
                handler(newData) {
                    // Guardar datos de pago en localStorage cuando cambian
                    try {
                        localStorage.setItem('tupibox_pay_data', JSON.stringify(newData));
                    } catch (e) {
                        console.error('Error guardando datos de pago:', e);
                    }
                },
                deep: true
            }
        },
        mounted() {
            console.log('🎯 [StepCheckout] Component mounted!');
            console.log('🎯 [StepCheckout] product_type:', this.formData.product_type);
            
            // Restaurar datos de pago guardados
            try {
                const savedPayData = localStorage.getItem('tupibox_pay_data');
                if (savedPayData) {
                    this.payData = JSON.parse(savedPayData);
                    console.log('✅ Datos de pago restaurados desde localStorage');
                }
            } catch (e) {
                console.error('Error restaurando datos de pago:', e);
            }
            
            // Capturar pre-checkout automáticamente al llegar al paso de checkout
            this.capturePreCheckout();
        },
        methods: {
            async capturePreCheckout() {
                console.log('🎯 [StepCheckout] capturePreCheckout called');
                console.log('🎯 [StepCheckout] Checking product_type:', this.formData.product_type);
                
                // Solo enviar si es Fresh (opcional: puedes eliminar el if para capturar todos)
                if (this.formData.product_type === 'fresh') {
                    try {
                        const payload = {
                            ...this.formData,
                            stage: 'pre-checkout',
                            timestamp: new Date().toISOString(),
                            // Asegurar que deliveryFrequency esté presente
                            deliveryFrequency: this.formData.deliveryFrequency || '1x'
                        };
                        
                        console.log('💳 [StepCheckout] PRE-CHECKOUT PAYLOAD:');
                        console.log('=====================================');
                        console.log(JSON.stringify(payload, null, 2));
                        console.log('=====================================');
                        console.log('💳 [StepCheckout] Campos críticos:');
                        console.log('  - ageInMonths:', payload.ageInMonths);
                        console.log('  - activityLevel:', payload.activityLevel);
                        console.log('  - proteinPreference:', payload.proteinPreference);
                        console.log('  - currentFood:', payload.currentFood);
                        console.log('  - digestiveSensitivities:', payload.digestiveSensitivities);
                        console.log('  - portions:', payload.portions);
                        console.log('  - deliveryFrequency:', payload.deliveryFrequency);
                        
                        await this.axios({
                            method: 'post',
                            url: 'https://hook.us1.make.com/jmo8vypt3ll9nvdvsnc1i8u9skgvg4mj',
                            data: payload
                        });
                        console.log('✅ Pre-checkout capturado');
                    } catch (error) {
                        // Ignorar errores (no bloquear el checkout)
                        console.error('❌ Error capturando pre-checkout:', error);
                    }
                }
            },
            formatPhoneNumber() {
                // Remover todo excepto números
                let phone = this.payData.phone.replace(/\D/g, '');
                
                // Limitar a 9 dígitos
                if (phone.length > 9) {
                    phone = phone.substring(0, 9);
                }
                
                // Formatear: 9 1234 5678
                if (phone.length > 4) {
                    phone = phone.substring(0, 1) + ' ' + phone.substring(1, 5) + ' ' + phone.substring(5);
                } else if (phone.length > 1) {
                    phone = phone.substring(0, 1) + ' ' + phone.substring(1);
                }
                
                this.payData.phone = phone;
            },
            getPhoneWithPrefix() {
                // Retorna el teléfono con prefijo +56 para el backend
                const cleanPhone = this.payData.phone.replace(/\D/g, '');
                return '+56' + cleanPhone;
            },
          getPlanName() {
              const weight = this.formData.weight || 10
              if (weight <= 7) return 'Pequeño'
              if (weight <= 15) return 'Mediano'
              if (weight <= 30) return 'Grande'
              return 'Gigante'
          },
          getPortions() {
              const weight = this.formData.weight || 10
              if (weight <= 7) return 7
              if (weight <= 15) return 14
              if (weight <= 30) return 28
              return 49
          },
          async getPlanId(discont) {
            // Mapeo directo de planes a IDs de MercadoPago
            const PLAN_IDS = {
              // Fresh
              'fresh_small_5kg_x1': 'e680742e7f094522ab918bce5e465c9d',
              'fresh_small_5kg_x3': '43ffcaba850b4771abed88ad4d229770',
              'fresh_small_5kg_x6': 'a6bc7d47bcac4bd9a8d0d21a081cb2f9',
              'fresh_medium_10kg_x1': '1614c444d2bd4642a7b31583670bd614',
              'fresh_medium_10kg_x3': 'e4d02dc1f9d54247b18060ddda530c03',
              'fresh_medium_10kg_x6': '585c833307cf4c3380dd3b5a9957d7ac',
              'fresh_large_20kg_x1': '7be112e300904475b59ec9a6c748fd69',
              'fresh_large_20kg_x3': '471007fc38774c63a8b1c25a32418687',
              'fresh_large_20kg_x6': 'aa071a673f694016b0ec7706adf893c6',
              'fresh_giant_35kg_x1': '2cacd574a5204cb6ad00a33fee4c777b',
              'fresh_giant_35kg_x3': '9dd5491562a942c595b86654707553c0',
              'fresh_giant_35kg_x6': '8baadd8d5a2d4c80a16715b9f1d6fd47',
              // Toys
              'light_x1': '52eb9211451942c4bb306da3496e1b8a',
              'light_x3': '6f30ab746e714a878e4c3d6ea449fd9e',
              'light_x6': 'b344800a9b754f80b0ce71e4e6dfd266',
              'normal_x1': 'da83de7e06364552b9419a463ca001b1',
              'normal_x3': 'ea992f8a10a948afa566fcb46b7cf59c',
              'normal_x6': '42c6e53c692b432284a007248f84f34c'
            };
            
            let planKey = this.formData.plan;
            let planId = PLAN_IDS[planKey];
            
            if (!planId) {
              console.error(`❌ Plan no encontrado: ${planKey}`);
              throw new Error(`Plan ${planKey} no tiene ID de MercadoPago configurado`);
            }
            
            console.log(`✅ Plan: ${planKey} → MP ID: ${planId}`);
            return planId;
          },
            async submitPayForm(){

                this.$v.$touch()
                if (!this.$v.$invalid) {
                    
                  let formData = this.formData
                    
                    this.payload = {
                        x_account_id : process.env.VUE_APP_TUPIBOX_PAYMENT_PUBLIC_KEY,
                        x_amount : formData.price,
                        x_currency : 'CLP',
                        x_reference : shortid.generate(),
                        x_customer_email : formData.email,
                        x_url_complete : 'https://go.tupibox.com/response?status=complete',
                        x_url_cancel : 'https://go.tupibox.com/response?status=cancel',
                        x_url_callback : 'https://go.tupibox.com/response?status=callback',
                        x_signature : '',
                        x_shop_country : 'CL',
                        x_session_id : uuidv4(),
                    }
                    
                    let allData = {
                        ...formData,
                        ...this.payData,
                        ...this.payload,
                        plan: `${formData.plan}-${formData.payMethod}`,
                        // Asegurar que deliveryFrequency esté presente
                        deliveryFrequency: formData.deliveryFrequency || '1x',
                        // Campos adicionales para Fresh
                        portions: formData.portions || null,
                        recommendedPortions: formData.recommendedPortions || null,
                        adjustedPortions: formData.adjustedPortions || null
                    }

                    console.log('📤 [StepCheckout] Enviando a Google Sheets:');
                    console.log('  - deliveryFrequency:', allData.deliveryFrequency);
                    console.log('  - portions:', allData.portions);
                    console.log('  - product_type:', allData.product_type);
                    console.log('  - plan:', allData.plan);

                    let req = await this.axios({
                        method: 'post',
                        url: 'https://hook.us1.make.com/w851pw12ewr6uytb3cscbvkjkxjp9hvc',
                        data: allData
                    })

                    let paymentType = this.formData.payMethod === 'subscription' ? 'suscripción' : 'pago único'
                    let descripcion = `TupiBox para ${this.formData.petname}, ${paymentType} x ${this.multiplier} meses`

                    this.formData.frequency = this.multiplier

                    let orderData = {
                      external_reference: this.payload.x_reference,
                      description: descripcion,
                      price: this.formData.price,
                      plan: null // No plan needed - flexible subscriptions
                    }
                    
                    this.renderPaymentBrick(orderData);

                }

            },
            async renderPaymentBrick(data) {
                let settings = {
                    initialization: {
                        amount: this.formData.price,
                        payer: {
                            email: this.payData.email,
                        },
                    },
                    customization: {
                        visual: {
                            style: {
                                theme: "default",
                            },
                        },
                        paymentMethods: {
                            maxInstallments: 1
                        },
                    },
                    callbacks: {
                        onReady: () => {
                        },
                        onSubmit: (payFormData) => {
                            return new Promise((resolve, reject) => {
                                // this.formData.price YA incluye descuentos aplicados
                                // Solo agregar extras si corresponde
                                let finalAmount = this.formData.price;
                                
                                // Add extra toy/snacks if selected
                                if (this.formData.extraToy === 'Si') {
                                    const extraPrice = this.formData.product_type === 'fresh' 
                                        ? this.prices.extra_snacks 
                                        : this.prices.extratoy;
                                    finalAmount += extraPrice;
                                }
                                
                                // Ensure amount is positive
                                finalAmount = Math.max(finalAmount, 100); // Minimum $100 CLP
                                
                                let allData = {
                                    ...this.formData,
                                    ...this.payData,
                                    ...payFormData,
                                    ...this.payload,
                                    description: data.description,
                                    transaction_amount: finalAmount, // Use calculated amount
                                    payMethod: this.formData.payMethod,
                                    frequency: this.multiplier, // x1, x3, x6 months
                                    phone: this.getPhoneWithPrefix() // Add +56 prefix
                                }
                                // No plan needed for flexible subscriptions
                                allData.planId = null
                                
                                console.log('📤 Sending to backend:', {
                                    url: process.env.VUE_APP_TUPIBOX_PAYMENT_API_URL + '/payment',
                                    payMethod: allData.payMethod,
                                    basePrice: this.formData.price,
                                    discount: this.formData.discountAmount || 0,
                                    upsell: this.formData.extraToy === 'Si' ? this.prices.extratoy : 0,
                                    finalAmount: allData.transaction_amount,
                                    frequency: allData.frequency,
                                    hasToken: !!allData.token,
                                    hasIssuerId: !!allData.issuer_id,
                                    hasPayerEmail: !!(allData.payer && allData.payer.email)
                                });
                                console.log('📤 Full payload:', JSON.stringify(allData, null, 2));
                                  
                                fetch(process.env.VUE_APP_TUPIBOX_PAYMENT_API_URL + '/payment', {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(allData),
                                })
                                .then((response) => {
                                    console.log('🔍 Response status:', response.status);
                                    console.log('🔍 Response OK:', response.ok);
                                    if (!response.ok) {
                                        throw new Error(`Backend error: ${response.status} ${response.statusText}`);
                                    }
                                    return response.text();
                                })
                                .then((text) => {
                                    console.log('🔍 Response text:', text);
                                    if (!text) {
                                        throw new Error('Backend returned empty response');
                                    }
                                    return JSON.parse(text);
                                })
                                .then(async (response) => {
                                    console.log('✅ Payment response:', response);
                                    document.querySelector(".overlay").style.visibility = "hidden";
                                    window.paymentBrickController.unmount();
                                    let result = {
                                      x_reference: this.payload.x_reference,
                                      x_account_id: this.payload.x_account_id,
                                      x_amount: this.formData.price,
                                      x_currency: "CLP",
                                      x_gateway_reference: "",
                                      x_result: "",
                                      x_test: "",
                                      x_timestamp: new Date().toLocaleString(),
                                      x_signature: "",
                                      gws_rd: "",
                                    }
                                    if (response.status === "authorized") {
                                      result.x_result = "completed";
                                      result.x_gateway_reference = response.id;
                                      
                                      // Enviar datos completos a Make.com webhook "Pagado"
                                      try {
                                        const confirmationPayload = {
                                          ...result,
                                          ...this.formData,
                                          ...this.payData,
                                          product_type: this.formData.product_type || 'fresh',
                                          payment_confirmed: true,
                                          deliveryFrequency: this.formData.deliveryFrequency || '1x',
                                          portions: this.formData.portions || null,
                                          recommendedPortions: this.formData.recommendedPortions || null,
                                          adjustedPortions: this.formData.adjustedPortions || null,
                                          phone: this.getPhoneWithPrefix()
                                        };
                                        
                                        console.log('📤 [StepCheckout] Enviando confirmación de pago:');
                                        console.log('  - deliveryFrequency:', confirmationPayload.deliveryFrequency);
                                        console.log('  - portions:', confirmationPayload.portions);
                                        console.log('  - phone:', confirmationPayload.phone);
                                        
                                        await this.axios({
                                          method: 'post',
                                          url: 'https://hook.us1.make.com/koycg0xsqb1dhod5hwpykp4w2yhyr1n5',
                                          data: confirmationPayload
                                        });
                                        console.log('✅ Pago confirmado enviado a Make.com');
                                      } catch (error) {
                                        console.error('❌ Error enviando confirmación a Make.com:', error);
                                        // No bloquear el flujo si falla Make.com
                                      }
                                      
                                        this.$router.push({
                                          path: '/response',
                                          query: { status: 'completed', ...result }
                                        })
                                    } else {
                                        result.x_result = "failed";
                                        this.$router.push({
                                          path: '/response',
                                          query: { status: 'failed', ...result }
                                        })
                                    }
                                    resolve();
                                })
                                .catch((error) => {
                                    console.error('❌ Payment error:', error);
                                    console.error('❌ Error message:', error.message);
                                    console.error('❌ Error stack:', error.stack);
                                    
                                    alert(`Error de pago: ${error.message}`);
                                    
                                    let result = {
                                      x_reference: this.payload.x_reference,
                                      x_account_id: this.payload.x_account_id,
                                      x_amount: this.formData.price,
                                      x_currency: "CLP",
                                      x_gateway_reference: "",
                                      x_result: "failed",
                                      x_test: "",
                                      x_timestamp: new Date().toLocaleString(),
                                      x_signature: "",
                                      gws_rd: "",
                                    }
                                    document.querySelector(".overlay").style.visibility = "hidden";
                                    window.paymentBrickController.unmount();
                                    this.$router.push({
                                      path: '/response',
                                      query: { status: 'failed', ...result }
                                    })
                                    reject();
                                });
                            });
                        },
                        onError: (error) => {
                            console.error(error);
                        },
                    },
                };
                document.querySelector(".overlay").style.visibility = "visible";
                document.querySelector(".overlay").addEventListener("click", () => {
                    document.querySelector(".overlay").style.visibility = "hidden";
                    window.paymentBrickController.unmount();
                });
                window.paymentBrickController = await this.$bricksBuilder.create(
                    "cardPayment",
                    "paymentBrick_container",
                    settings
                );
                let divLogo = document.querySelector('div.container-2EtaVo');

                if (divLogo) {
                  divLogo.insertAdjacentHTML('afterbegin', '<div><img src ="'+ Logo +'" alt="MercadoPago"/></div>');
                }

                let div = document.querySelector('div.row-3R86bN');

                if (div) {
                  div.insertAdjacentHTML('beforeend', '<div style="margin-top: 20px; max-width: 640px;">La informaci&oacute;n que ingresa est&aacute; encriptada con certificado SSL. Se utiliza la API segura de MercadoPago y ning&uacute;n dato de tarjeta se almacena en los servidores de Tupibox.</div>');
                }
            },
            async applyDiscount(){
                this.loadingDiscountCode = true

                let code = this.discountCode
                
                try {
                    let { data: resCode } = await axios.get(process.env.VUE_APP_API_TUPIBOX + '/codes/' + code)

                    if(resCode.status === 'success' && !this.formData.discountAmount){
                        // Calcular precio final después del descuento
                        const finalPrice = this.formData.price - resCode.data.amount;
                        
                        // Validar mínimo $950 para suscripciones (requisito MercadoPago)
                        if (this.formData.payMethod === 'subscription' && finalPrice < 950) {
                            this.$buefy.toast.open({
                                message: '❌ El monto final con descuento debe ser mínimo $950 CLP para suscripciones',
                                type: 'is-danger',
                                duration: 5000,
                                position: 'is-top'
                            });
                            this.loadingDiscountCode = false;
                            return;
                        }
                        
                        // Validación removida: getPlanId() ya no se usa con suscripciones dinámicas
                        
                        this.formData.price = finalPrice;
                        this.formData.discountCode = this.discountCode
                        this.formData.discountAmount = resCode.data.amount
                        this.disabledDiscount = true
                        this.loadingDiscountCode = false
                        
                        // Notificar éxito
                        this.$buefy.toast.open({
                            message: `✅ Cupón aplicado: -$${resCode.data.amount.toLocaleString()} CLP`,
                            type: 'is-success',
                            duration: 3000,
                            position: 'is-top'
                        });
                    } else {
                        this.$buefy.toast.open({
                            message: resCode.status === 'success' 
                                ? '⚠️ Ya tienes un cupón aplicado' 
                                : '❌ Cupón inválido o expirado',
                            type: 'is-warning',
                            duration: 4000,
                            position: 'is-top'
                        });
                        this.loadingDiscountCode = false;
                    }
                } catch (error) {
                    console.error('Error applying discount:', error);
                    this.$buefy.toast.open({
                        message: '❌ Error al verificar el cupón. Intenta de nuevo.',
                        type: 'is-danger',
                        duration: 4000,
                        position: 'is-top'
                    });
                    this.loadingDiscountCode = false;
                }
            }
        }
    }
</script>
